import GoogleTagManager from './google-tag-manager';

export default GoogleTagManager;
